'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherX } from '@subframe/core';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import type { BulkAction } from './types';
function resolverVisiveis(bulkActions: BulkAction[], selectedArray: string[]): BulkAction[] {
  return bulkActions.filter(action => !action.hidden?.(selectedArray));
}
interface BulkActionButtonProps {
  action: BulkAction;
  selectedArray: string[];
  total: number;
}
function BulkActionButton(t0) {
  const $ = _c(15);
  const {
    action,
    selectedArray,
    total
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== selectedArray) {
    t1 = typeof action.disabled === "function" ? action.disabled(selectedArray) : action.disabled ?? false;
    $[0] = action;
    $[1] = selectedArray;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isDisabled = t1;
  let t2;
  if ($[3] !== action || $[4] !== selectedArray) {
    t2 = action.count?.(selectedArray);
    $[3] = action;
    $[4] = selectedArray;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const elegiveis = t2;
  const parcial = elegiveis !== undefined && elegiveis < total;
  const t3 = action.variant ?? "neutral-secondary";
  let t4;
  if ($[6] !== action || $[7] !== selectedArray) {
    t4 = () => action.onClick(selectedArray);
    $[6] = action;
    $[7] = selectedArray;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = parcial ? `${action.label} · ${elegiveis} de ${total}` : action.label;
  let t6;
  if ($[9] !== action.icon || $[10] !== isDisabled || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <Button variant={t3} size="small" icon={action.icon} disabled={isDisabled} onClick={t4}>{t5}</Button>;
    $[9] = action.icon;
    $[10] = isDisabled;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
interface DataTableBulkBarProps {
  selectedIds: Set<string>;
  bulkActions: BulkAction[];
  onClearSelection: () => void;
}
export function DataTableBulkBar(t0) {
  const $ = _c(19);
  const {
    selectedIds,
    bulkActions,
    onClearSelection
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== bulkActions || $[1] !== selectedIds) {
    const selectedArray = Array.from(selectedIds);
    const visiveis = resolverVisiveis(bulkActions, selectedArray);
    t4 = "animate-in slide-in-from-bottom-2 bg-default-background sticky bottom-0 z-10 flex w-full items-center justify-between gap-3 border-t border-solid border-neutral-200 px-4 py-3";
    t1 = "flex flex-wrap items-center gap-3";
    if ($[6] !== selectedIds.size) {
      t2 = <Badge variant="neutral">{selectedIds.size} selecionada(s)</Badge>;
      $[6] = selectedIds.size;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t3 = visiveis.map(action => <BulkActionButton key={action.id} action={action} selectedArray={selectedArray} total={selectedIds.size} />);
    $[0] = bulkActions;
    $[1] = selectedIds;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherX />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClearSelection) {
    t7 = <IconButton icon={t6} size="small" onClick={onClearSelection} />;
    $[13] = onClearSelection;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
interface DataTableBulkFloatingProps {
  selectedIds: Set<string>;
  bulkActions: BulkAction[];
  onClearSelection: () => void;
}
export function DataTableBulkFloating(t0) {
  const $ = _c(21);
  const {
    selectedIds,
    bulkActions,
    onClearSelection
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== bulkActions || $[1] !== selectedIds) {
    const selectedArray = Array.from(selectedIds);
    const visiveis = resolverVisiveis(bulkActions, selectedArray);
    const temAcaoElegivel = visiveis.some(_temp);
    const haviaAcaoElegivel = bulkActions.some(_temp2);
    t5 = "pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4";
    t1 = "animate-in fade-in slide-in-from-bottom-2 bg-default-background pointer-events-auto flex max-w-[calc(100vw-2rem)] flex-wrap items-center justify-center gap-2 rounded-[16px] border border-solid border-neutral-200 px-4 py-3 shadow-lg";
    if ($[7] !== selectedIds.size) {
      t2 = <Badge variant="neutral">{selectedIds.size} selecionada(s)</Badge>;
      $[7] = selectedIds.size;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t3 = !temAcaoElegivel && haviaAcaoElegivel ? <span className="text-caption font-caption text-subtext-color">Sem ação em lote comum para esta seleção.</span> : null;
    t4 = visiveis.map(action_1 => <BulkActionButton key={action_1.id} action={action_1} selectedArray={selectedArray} total={selectedIds.size} />);
    $[0] = bulkActions;
    $[1] = selectedIds;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherX />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onClearSelection) {
    t7 = <IconButton icon={t6} size="small" onClick={onClearSelection} />;
    $[10] = onClearSelection;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t7) {
    t8 = <div className={t1}>{t2}{t3}{t4}{t7}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp2(action_0) {
  return action_0.count !== undefined;
}
function _temp(action) {
  return action.count !== undefined;
}
interface DataTableBulkHeaderProps {
  selectedIds: Set<string>;
  bulkActions: BulkAction[];
  onClearSelection: () => void;
}
export function DataTableBulkHeader(t0) {
  const $ = _c(8);
  const {
    selectedIds,
    bulkActions,
    onClearSelection
  } = t0;
  let t1;
  if ($[0] !== bulkActions || $[1] !== onClearSelection || $[2] !== selectedIds) {
    const selectedArray = Array.from(selectedIds);
    const visiveis = resolverVisiveis(bulkActions, selectedArray);
    let t2;
    if ($[4] !== selectedIds.size) {
      t2 = <Badge variant="neutral">{selectedIds.size} selecionadas</Badge>;
      $[4] = selectedIds.size;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== onClearSelection) {
      t3 = <Button variant="neutral-secondary" size="small" onClick={onClearSelection}>Limpar</Button>;
      $[6] = onClearSelection;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t1 = <div className="flex flex-wrap items-center gap-2">{t2}{t3}{visiveis.map(action => <BulkActionButton key={action.id} action={action} selectedArray={selectedArray} total={selectedIds.size} />)}</div>;
    $[0] = bulkActions;
    $[1] = onClearSelection;
    $[2] = selectedIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}